import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import LoadingOverlay from "react-loading-overlay";
import { SimpleCard } from "@gull";

const ListaPerfis = ({
  showModal = false,
  lista = [],
  toggleModal,
  realizaLogin,
}) => {
  const [show, setShow] = useState(false);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    setShow(showModal);
  }, [showModal]);

  return (
    <Modal show={show} onHide={toggleModal} backdrop="static" size="md">
      <Modal.Header closeButton>
        <Modal.Title>Perfis do usuário</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <LoadingOverlay
          active={loader}
          spinner={
            <div className="spinner-bubble spinner-bubble-primary m-5"></div>
          }
          styles={{
            overlay: (base) => ({
              ...base,
              background: "transparent",
            }),
          }}
        >
          <div className="row">
            <div className="col-sm-12">
              <SimpleCard className="h-100" title="Selecione o perfil desejado">
                <div className="ul-widget-app__comments">
                  {(() => {
                    const retorno = [];

                    lista.map((perfil) => {
                      const { txLogo, nmUsuario, idTipo, nmEscola } = perfil;

                      retorno.push(
                        <div
                          className="ul-widget-app__row-comments"
                          onClick={() => {
                            setLoader(true);
                            realizaLogin(perfil);
                          }}
                        >
                          <div className="ul-widget-app__profile-pic p-3">
                            <img
                              className="profile-picture avatar-md mb-2 rounded-circle img-fluid"
                              src={txLogo}
                            />
                          </div>
                          <div className="ul-widget-app__comment">
                            <div className="ul-widget-app__profile-title">
                              <h6 className="heading">{nmUsuario}</h6>
                              <p className="mb-2">{nmEscola}</p>
                            </div>
                            <div className="ul-widget-app__profile-status">
                              {(() => {
                                const descricaoPerfil = [];

                                switch (idTipo) {
                                  case 1:
                                    descricaoPerfil.push(
                                      <span className="badge badge-pill badge-primary p-2 m-1">
                                        Administrador
                                      </span>
                                    );
                                    break;

                                  case 2:
                                    descricaoPerfil.push(
                                      <span className="badge badge-pill badge-info p-2 m-1">
                                        Secretaria
                                      </span>
                                    );
                                    break;
                                  case 3:
                                    descricaoPerfil.push(
                                      <span className="badge badge-pill badge-warning p-2 m-1">
                                        Professor(a)
                                      </span>
                                    );
                                    break;
                                  case 5:
                                    descricaoPerfil.push(
                                      <span className="badge badge-pill badge-success p-2 m-1">
                                        Financeiro
                                      </span>
                                    );
                                    break;

                                  default:
                                    descricaoPerfil.push(
                                      <span className="badge badge-pill badge-success p-2 m-1">
                                        Não definido
                                      </span>
                                    );
                                    break;
                                }

                                return descricaoPerfil;
                              })()}
                              {/*
                            <span className="ul-widget-app__icons">
                              <span className="cursor-pointer pl-2 pr-1 text-small">
                                <i className="i-Approved-Window text-mute"></i>
                              </span>
                              <span className="cursor-pointer pr-1 text-small">
                                <i className="i-Like text-mute"></i>
                              </span>
                              <span className="cursor-pointer text-small">
                                <i className="i-Heart1 text-mute"></i>
                              </span>
                            </span>
                            <span className="text-mute text-small">
                              May 14, 2019
                            </span>
                            */}
                            </div>
                          </div>
                        </div>
                      );
                    });

                    return retorno;
                  })()}
                </div>
              </SimpleCard>
            </div>
          </div>
        </LoadingOverlay>
      </Modal.Body>
    </Modal>
  );
};

export default ListaPerfis;
